<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2022-02-16 11:20:43
 * @LastEditTime: 2022-03-02 10:03:11
 * @Description: 字段权限
-->
<template>
  <div id="source_permission_set" v-loading="loadingTree">
    <!-- 中间树结构 -->
    <div class="tree_content h100">
      <div class="left_tree_box center_tree_box bg-F9 h100 pt-3">
        <el-radio-group v-model="treeType" size="small" class="ml-5 tree-tabs-wrapper">
          <el-radio-button label="WEB"></el-radio-button>
          <el-radio-button label="APP"></el-radio-button>
        </el-radio-group>
        <div class="pl-4 pr-4">
          <el-input
            v-model="centerSearchText"
            class="self-filter-input"
            placeholder="搜索"
            clearable
            @keyup.enter.native="filterTree"
            @input="filterTree"
            @clear="filterTree"
          >
            <i slot="suffix" class="pr-1" @click="filterTree">
              <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
            </i>
          </el-input>
        </div>
        <div class="flex justify-between">
          <div class="pl-4">
            <span class="vertical-bar fnM">资源列表</span>
          </div>

          <div class="pr-4 sicm-sub-text-color text-gray-901">
            <span class="cursor-pointer hover:text-primary" @click="expandTree(true)">展开</span>
            <span class="pr-2 pl-2">|</span>
            <span class="cursor-pointer hover:text-primary" @click="expandTree(false)">收起</span>
          </div>
        </div>
        <div class="overflow-y-scroll tree_height mt-2 pb-1">
          <el-tree
            ref="centerTree"
            class="self-tree data_tree"
            node-key="id"
            :props="defaultProps"
            :data="treeData"
            :highlight-current="true"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
          >
            <span slot-scope="{ node }" class="self-custom-tree leading-8">
              <span
                :class="node.isCurrent ? '' : node.data.resourceType === 0 ? 'text-blue-3377' : ''"
              >
                <svg-icon
                  v-if="node.data.icon"
                  :icon-class="node.data.icon"
                  class="mr-1"
                ></svg-icon>
                {{ node.label }}
              </span>
            </span>
          </el-tree>
        </div>
      </div>

      <!-- 右边内容 -->
      <div
        class="right_content mt-3"
        v-if="centerCurrentNode && centerCurrentNode.resourceType !== 'RESOURCE'"
      >
        <div class="top_info_box">
          <span class="vertical-bar fn18 fnM">{{ centerCurrentNode.resourceName }}</span>
          <div class="detail_box">
            <div class="detail_resource_path">
              菜单编码：
              <span v-if="centerCurrentNode.resourceCode">
                {{ centerCurrentNode.resourceCode }}
              </span>
              <span v-else class="empty_description">暂无</span>
            </div>
            <div class="detail_sort">排序：{{ centerCurrentNode.sort }}</div>
          </div>
        </div>
        <div class="split_bar"></div>
      </div>
      <div style="width: 100%;height: 100%;overflow: auto" v-if="centerCurrentNode && centerCurrentNode.resourceType === 'RESOURCE'">
        <div class="search_box pb-3" style="padding:24px;border-bottom: 1px solid #e9e9eb">
          <span class="vertical-bar fn18 fnM" style="line-height: 32px">
            字段列表 ( {{ centerCurrentNode === null ? '' : centerCurrentNode.resourceName }} )
          </span>
          <el-button
            size="small"
            class="float-right"
            type="primary"
            style="width: 80px"
            :loading="saving"
            :disabled="tableData.length === 0"
            @click="saveField"
          >
            保存
          </el-button>
          <el-button
            size="small"
            class="float-right"
            style="margin-right: 8px; width: 80px"
            @click="reset"
          >
            重置
          </el-button>
          <el-input
            v-model="tableSearch"
            size="small"
            placeholder="请输入关键字"
            style="width: 303px"
            class="float-right"
            clearable
            @clear="reset"
            @keyup.enter.native="reset"
          >
            <i slot="suffix" class="pr-2" @click="reset">
              <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
            </i>
          </el-input>
        </div>
        <div style="overflow: auto;height: calc(100% - 81px)" v-if="!loading">
          <template v-for="(dataGroup,index) in this.tableDataTree">
            <div class="split_bar"></div>
            <div class="table_content">
              <div class="title">
                <span class="vertical-bar fn18 fnM" style="line-height: 32px">{{dataGroup.title}}</span>
              </div>
              <el-table
                border
                :stripe="true"
                row-key="id"
                default-expand-all
                :data="dataGroup.dataList"
                :tree-props="{children: 'children'}"
              >
                <el-table-column prop="sname" fixed label="资源名称" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ $t(scope.row.resourceElementLabel) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="自定义名称"
                  prop="resourceElementExtendLabel"
                  width="120"
                  show-overflow-tooltip
                />
                <el-table-column prop="resourceElementCode" label="资源标识" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{ scope.row.resourceElementCode }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="resourceStructureTypeDesc"
                  label="类型"
                  width="90"
                ></el-table-column>
                <el-table-column width="100">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox
                      label="不可见"
                      v-model="dataGroup.selectAll.notShow"
                      @change="val => checkAll(dataGroup,'notShow',val)"
                    ></el-checkbox>
                  </template>
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row.notShow"
                      :disabled="scope.row.required"
                      @change="val => changeCheck(scope.row,dataGroup, 'notShow',val)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column width="100">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox
                      label="只读"
                      v-model="dataGroup.selectAll.onlyRead"
                      @change="val => checkAll(dataGroup,'onlyRead',val)"
                    ></el-checkbox>
                  </template>
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row.onlyRead"
                      :disabled="scope.row.required"
                      @change="val => changeCheck(scope.row,dataGroup, 'onlyRead',val)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column width="100">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox
                      label="可操作"
                      v-model="dataGroup.selectAll.readyAction"
                      @change="val => checkAll(dataGroup,'readyAction',val)"
                    ></el-checkbox>
                  </template>
                  <template slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row.readyAction"
                      :disabled="scope.row.required"
                      @change="val => changeCheck(scope.row,dataGroup, 'readyAction',val)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </template>
        </div>
        <div v-else class="mask">
          <span class="text"><i class="el-icon-loading"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resourceApi from "@/api/data-permission/dataPermission";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";

export default {
  name: "ResourcePermissionSet",
  props: {
    targetId: {
      type: String,
      default() {
        return "";
      }
    },
    targetType: {
      type: String,
      default() {
        return "2";
      }
    }
  },
  data() {
    return {
      loading: true,
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      centerSearchText: "",
      treeData: [],
      centerCurrentNode: "",
      defaultShowNodes: [],
      tableData: [], //for save
      tableDataTree: [], //for render
      saving: false,
      tableSearch: "",
      /*notShow: false,
      onlyRead: false,
      readyAction: false,*/
      loadingTree: false,
      treeType: "WEB"
    };
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  watch: {
    /*tableData(arr) {
      if (arr.length > 0) {
        this.notShow = arr.every(item => item.notShow || item.required);
        this.onlyRead = arr.every(item => item.onlyRead || item.required);
        this.readyAction = arr.every(item => item.readyAction);
      }
    },*/
    targetId() {
      this.getAuthorResourceTree();
    },
    treeType() {
      this.centerSearchText = "";
      this.filterTree();
      this.getAuthorResourceTree();
    }
  },
  mounted() {
    this.getAuthorResourceTree();
    this.expandTree(false);
    // this.getCenterTreeList();
  },
  methods: {
    handleTreeData(children) {
      children.forEach(element => {
        const { resourceType } = element;
        element.icon =
          resourceType === "DIRECTORY" ? "icon_floder" : resourceType === "MENU" ? "icon_menu" : "";
        if (element.children) {
          this.handleTreeData(element.children);
        }
      });
    },
    // 获取带权限资源树
    getAuthorResourceTree() {
      if (!this.targetId) {
        return;
      }
      this.centerSearchText = "";
      this.treeData = [];
      this.centerCurrentNode = "";
      this.defaultShowNodes = [];
      this.tableData = [];
      this.saving = false;
      this.tableSearch = "";
      this.notShow = false;
      this.onlyRead = false;
      this.readyAction = false;
      this.loadingTree = true;
      resourceApi
        .getAuthorResourceTree(this.targetType, this.targetId, this.treeType, { parseToTree: true })
        .then(res => {
          if (res && res.success) {
            this.handleTreeData(res.data);
            this.treeData = res.data;
            this.loadingTree = false;
            this.$nextTick(() => {
              if (!this.centerCurrentNode && res.data && res.data.length) {
                const [node] = res.data;
                this.centerCurrentNode = node;
                this.defaultShowNodes.push(node.id);
              }
              if (this.centerCurrentNode.id) {
                this.$refs.centerTree &&
                  this.$refs.centerTree.setCurrentKey(this.centerCurrentNode.id);
                this.centerCurrentNode = this.$refs.centerTree.getCurrentNode();
              }

              if (this.targetId && this.centerCurrentNode.resourceType === "RESOURCE") {
                this.getFieldList();
              }
            });
          }
        })
        .catch(() => {
          this.loadingTree = false;
        });
    },

    /*
     * 重置
     */
    reset() {
      this.getFieldList();
    },
    // 获取字段权限列表
    getFieldList(ob) {
      this.loading = true;
      const params = {
        resourceId: this.centerCurrentNode.id,
        targetId: this.targetId,
        targetType: this.targetType,
        search: this.tableSearch
      };
      if (ob && !ob.ac) {
        return;
      }
      resourceApi
        .getFieldList(params)
        .then(res => {
          debugger;
          this.tableData = res.data.map(item => {
            item = {
              ...item,
              notShow: false,
              onlyRead: false,
              readyAction: false,
              targetId: this.targetId,
              id: item.resourceElementId,
              targetType: this.targetType,
              required: item.required
            };
            if (item.permission === 1) {
              item.notShow = true;
            }
            if (item.permission === 2) {
              item.onlyRead = true;
            }
            if (item.permission === 3) {
              item.readyAction = true;
            }
            return item;
          }).filter(item => item.resourceElementLabel !== "");

          const tableDataGroupByType = [];
          this.tableData.forEach(item => {
            const groupDataIndex = tableDataGroupByType.findIndex(ele => ele.type === item.resourceStructureTypeDesc);
            //Component not exist in group data
            if (groupDataIndex === -1) {
              tableDataGroupByType.push({
                type: item.resourceStructureTypeDesc,
                resourceElementCode: item.resourceElementCode,
                dataList: [item]
              });
            } else {
              tableDataGroupByType[groupDataIndex].dataList.push(item);
            }
          });

          this.$set(this, "tableDataTree", []);
          const groupCodeInTree = [];
          let newGroup = null;
          tableDataGroupByType.forEach(item => {
            if (item.dataList.length === 1) {
              groupCodeInTree.push(item.resourceElementCode);
              const treeRoot = item.dataList[0];
              tableDataGroupByType.forEach(item2 => {
                if (item2.dataList.length !== 1 && item2.dataList.findIndex(data => data.resourceElementCode.startsWith(item.resourceElementCode)) !== -1) {
                  treeRoot.children = item2.dataList;
                  groupCodeInTree.push(item2.resourceElementCode);
                }
              });

              newGroup = {
                title: treeRoot.resourceStructureTypeDesc,
                selectAll: {
                  notShow: undefined,
                  onlyRead: undefined,
                  readyAction: undefined
                },
                dataList: [treeRoot]
              };
              this.tableDataTree.push(newGroup);
              this.getTableSelectAllCheckByGroup(newGroup);
            }
          });

          tableDataGroupByType.forEach(item => {
            if (groupCodeInTree.findIndex(code => item.resourceElementCode === code) === -1) {
              newGroup = {
                title: item.dataList[0].resourceStructureTypeDesc,
                selectAll: {
                  notShow: undefined,
                  onlyRead: undefined,
                  readyAction: undefined
                },
                dataList: item.dataList
              };
              this.tableDataTree.push(newGroup);
              this.getTableSelectAllCheckByGroup(newGroup);
            }
          });

          this.$set(this.tableData);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getTableSelectAllCheck(dataList, colName) {
      let hasUnchecked = false;

      for (let i = 0; i < dataList.length; i++) {
        if (dataList[i][colName] === false) {
          hasUnchecked = true;
          break;
        } else if (dataList[i].children && dataList[i].children.length > 0) {
          for (let j = 0; j < dataList[i].children.length; j++) {
            if (dataList[i].children[j][colName] === false) {
              hasUnchecked = true;
              break;
            }
          }
        }

        if (hasUnchecked) {
          break;
        }
      }

      return !hasUnchecked;
    },

    getTableSelectAllCheckByGroup(group) {
      group.selectAll.notShow = this.getTableSelectAllCheck(group.dataList, "notShow");
      group.selectAll.onlyRead = this.getTableSelectAllCheck(group.dataList, "onlyRead");
      group.selectAll.readyAction = this.getTableSelectAllCheck(group.dataList, "readyAction");
    },

    /**
     * @description:展开收起菜单树
     * @param {*} expand
     * @return {*}
     */
    expandTree(expand) {
      const { nodesMap } = this.$refs.centerTree.store;
      for (const key in nodesMap) {
        // 全部关闭
        if (key === "-2") {
          nodesMap[key].expanded = true;
        } else {
          nodesMap[key].expanded = expand;
        }
      }
    },

    handleFilter(str) {
      if (!this.centerFilterText || !str) {
        return str;
      }
      const index = str.indexOf(this.centerFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.centerFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.centerFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    leftFilterTree() {
      this.leftFilterText = this.leftSearchText;
      this.$refs.leftTree.filter(this.leftSearchText);
    },
    filterTree() {
      this.centerFilterText = this.centerSearchText;
      this.$refs.centerTree.filter(this.centerSearchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },

    handleNodeClick(node) {
      this.centerCurrentNode = node;
      this.tableData = [];

      if (this.centerCurrentNode.resourceType === "RESOURCE") {
        this.getFieldList();
      }

      /*
       * this.getResourceDetail();
       * this.getDetailList();
       */
    },
    // 保存修改
    saveField() {
      this.tableData = this.tableData.map(item => {
        item.permission = 3;
        if (item.notShow) {
          item.permission = 1;
        }
        if (item.onlyRead) {
          item.permission = 2;
        }
        if (item.readyAction) {
          item.permission = 3;
        }
        return item;
      });
      this.saving = true;

      const tableDataCopy = JSON.parse(JSON.stringify(this.tableData));
      tableDataCopy.forEach(data => {
        delete data.children;
      });

      resourceApi.saveFieldList(tableDataCopy)
        /*.saveFieldList(this.tableData)*/
        .then(res => {
          this.saving = false;
          if (res && res.success) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "保存失败",
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.saving = false;
        });
    },

    checkAll(dataGroup, attrName, newValue) {
      dataGroup.dataList.forEach(data => {
        data[attrName] = newValue;
        this.changeCheck(data, undefined, attrName, newValue);

        if (data.children && data.children.length > 0) {
          data.children.forEach(child => {
            child[attrName] = newValue;
            this.changeCheck(child, undefined, attrName, newValue);
          });
        }
      });

      this.getTableSelectAllCheckByGroup(dataGroup);
    },
    changeCheck(data, dataGroup, attrName, newValue) {
      if (newValue === true) {
        switch (attrName) {
          case "notShow": {
            data.onlyRead = false;
            data.readyAction = false;
            break;
          }
          case "onlyRead": {
            data.notShow = false;
            data.readyAction = false;
            break;
          }
          case "readyAction": {
            data.notShow = false;
            data.onlyRead = false;
            break;
          }
        }
      }

      if (dataGroup){
        this.getTableSelectAllCheckByGroup(dataGroup);
      }
    }
  }
};
</script>

<style scoped lang="scss">
#source_permission_set {
  width: 100%;
  height: calc(100% + 11px);
  display: flex;
  .left_tree_box {
    width: 224px;
    margin-left: 0;
    transition: all 0.25s linear;
    background-color: #f9f9fb;
    position: relative;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    min-width: calc(100% - 324px);
    .center_tree_box {
      position: relative;
      flex: 0 244px;
      width: 324px;
    }
    .right_content {
      flex: 1;
      padding-bottom: 0px;
      padding-left: 16px;
      padding-right: 24px;
      height: 100%;
      width: calc(100% - 324px);
      transition: all 0.6s ease-in;

      .top_info_box {
        padding: 24px;
        .detail_box {
          display: flex;
          margin-top: 24px;
          line-height: 20px;
          justify-content: center;
          align-items: center;
          .detail_resource_path {
            flex: 1;
          }

          .detail_sort {
            width: 120px;
          }

          .menu_setting {
            margin-left: 40px;
          }
        }
      }

      .split_bar {
        height: 8px;
        width: 100%;
        background-color: #f9f9fb;
      }
      .search_box {
        overflow: hidden;
      }
    }
  }
}
</style>

<style lang="scss">
#source_permission_set {
  .self-filter-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
      line-height: 32px;
    }
  }
  .el-radio-group {
    margin-top: 0px;
  }
  .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 103px;
      font-size: 14px;
    }
  }

  .el-button--small {
    padding: 8px 16px;
    box-shadow: none;
  }
  .el-checkbox {
    .el-checkbox__label {
      padding-left: 5px;
    }
  }

  //   重写table样式-小型
  .small_table {
    .el-table {
      th {
        padding: 6px 0;
        height: 36px;
      }
      th:first-child {
        padding-left: 10px;
      }
      .el-input {
        margin-bottom: 0;
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
      td {
        padding: 4px 0;
        height: 32px;
      }
      td:first-child {
        padding-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
      .el-pagination__total {
        height: 24px;
        line-height: 24px;
      }
      button {
        height: 24px;
        line-height: 24px;
        min-width: 24px;
      }
      .el-pager {
        .number {
          height: 24px;
          line-height: 24px;
          min-width: 24px;
        }
      }
      .pagination-jumper {
        height: 24px;
        line-height: 24px;
        input {
          width: 24px;
          height: 24px;
          line-height: 24px;
        }
      }
      .pagination-sizes {
        height: 24px;
        line-height: 24px;
        .pagination-select {
          height: 24px;
          .el-input {
            .el-input__inner {
              height: 24px;
            }
          }
        }
      }
    }
  }

  .tree_height {
    height: calc(100% - 106px);
  }

  .tree-tabs-wrapper {
    .el-radio-button {
      .el-radio-button__inner {
        width: 103px;
        font-size: 12px;
      }
    }
  }
}
.split_bar {
  height: 8px;
  width: 100%;
  background-color: #f9f9fb;
}
  .table_content{
    padding:24px;
    .title{
      margin-bottom: 20px;
    }
  }

.mask {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    transform: scale(3.5);
  }
}
</style>
